import "bootstrap/dist/css/bootstrap.min.css";
import './css/data.css';
import logo from './img/logo.png';

import {Link} from 'react-router-dom';

function Sidebar(props) {

    const nameSidebar = ['Dashboard','Orders','Analytics','Accounting']

    return (
      <div className="d-flex flex-column flex-shrink-0 p-3 sidebar">
        <div className="d-flex align-items-center my-4">
          <img src={logo} className="img-responsive" width="40" height="40"></img>
          <h4 className="text-white p-1">Coffery</h4>
        </div>
        <ul className="nav nav-pills flex-column mb-auto">
          {nameSidebar.map((item)=> 
          <Link className={`${props.selected === item ? ('nav-item text-white') : ('text-white') } nav-link`} to={`${(item.toLowerCase()) === 'dashboard' ? ('/') : ('/'+item.toLowerCase())}`}>{item}</Link>
          )}
        </ul>
        <h5 className="relative text-white">Copyright 2023</h5>
    </div>
    );
  }
  
export default Sidebar;